import { cn } from '@seen/ui'
import type { ReactNode } from 'react'

export function LabelColor({
  color,
  className,
}: {
  color: string | undefined
  className?: string
}): ReactNode {
  return (
    <div
      style={{
        backgroundColor: color,
      }}
      className={cn(
        'max-h-2.25 min-h-2.25 min-w-2.25 max-w-2.25 rounded-full',
        className
      )}
    />
  )
}
